export var IntelligentPhotoCaptureScoreName;
(function (IntelligentPhotoCaptureScoreName) {
    IntelligentPhotoCaptureScoreName["BRIGHTNESS"] = "Brightness";
    IntelligentPhotoCaptureScoreName["CONTRAST"] = "Contrast";
    IntelligentPhotoCaptureScoreName["COLOR"] = "Color";
    IntelligentPhotoCaptureScoreName["FOCUS"] = "Focus";
    IntelligentPhotoCaptureScoreName["LIGHTING"] = "Lighting";
})(IntelligentPhotoCaptureScoreName || (IntelligentPhotoCaptureScoreName = {}));
//# sourceMappingURL=IntelligentPhotoCaptureScoreName.js.map